"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxMode = void 0;
let ProductBoxMode = exports.ProductBoxMode = /*#__PURE__*/function (ProductBoxMode) {
  ProductBoxMode["Concept"] = "concept";
  ProductBoxMode["Product"] = "product";
  return ProductBoxMode;
}({});
//# sourceMappingURL=ProductBoxMode.js.map